import { Box, ButtonGroup } from "@mui/material"
import type { ReactElement } from "react"
import { useState } from "react"
import { twMerge } from "tailwind-merge"

import { Button } from "@/components/common/Button"
import { SectionContainer } from "@/components/SectionContainer/SectionContainer"

interface PageTabsProps<T> {
  tabs: T[]
  renderContent: (tab: T) => JSX.Element
  renderSideContent?: (tab: T) => JSX.Element | null
}

const PageTabs = <T,>({ tabs, renderContent, renderSideContent }: PageTabsProps<T>): ReactElement => {
  const [tab, settab] = useState<T>(tabs[0])

  return (
    <SectionContainer className='flex flex-col gap-4 overflow-hidden'>
      <Box className='flex justify-between'>
        <ButtonGroup color='inherit' orientation='horizontal' variant='outlined' className='border-2 border-gray-300'>
          {tabs.map((tabItem) => (
            <Button
              key={String(tabItem)}
              onClick={() => settab(tabItem)}
              className={twMerge([
                "h-9 rounded-none rounded-l-sm border-gray-400 uppercase text-gray-700",
                tab === tabItem ? "bg-gray-300" : "",
              ])}
              appearance='text'
            >
              {String(tabItem)}
            </Button>
          ))}
        </ButtonGroup>
        {renderSideContent?.(tab)}
      </Box>
      {renderContent(tab)}
    </SectionContainer>
  )
}

export default PageTabs
